import { IoMdDownload } from 'react-icons/io';
import { MdLocalPrintshop, MdOutlineClose, MdOutlineKeyboardBackspace } from 'react-icons/md';
import { useNavigate, useParams } from 'react-router-dom';
import ServiceInvoice from './serviceInvoice';
import { useReactToPrint } from 'react-to-print';
import html2pdf from 'html2pdf.js';
import { FaEye } from 'react-icons/fa';
import { useEffect, useState,useRef  } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const Base_Url = process.env.REACT_APP_BASE_URL;
export default function ViewInvoice() {
  const navigate=useNavigate();
  const {id}=useParams();
  const [service , setService]=useState(null);
  
  useEffect(() => {
    if (id) fetchBookedServices();
  }, [id]);
  
    const fetchBookedServices = async () => {
    try { 
      const token = localStorage.getItem("token"); 
      const response = await axios.get(`${Base_Url}/api/bookedService/getBookedServiceDetails/${id}`, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (response.data.success) {
        setService(response.data.data);
      } else {
        toast.error(response.data.message || "Failed to fetch data");
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error.response?.data?.message || "Something went wrong while fetching"
      );
    } 
    };

   const invoiceRef = useRef(null);

  const handlePrint = useReactToPrint({
  contentRef: invoiceRef,
  documentTitle: `Invoice_${service?.bookedServiceId}`,
  onAfterPrint: () => {
    console.log("Print finished!");
  },
  });

  const handleDownload = () => {
  if (!invoiceRef.current) return;

  const element = invoiceRef.current;
  const opt = {
    margin: 0.5,
    filename: `Invoice_${service?.bookedServiceId}.pdf`,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
  };

  html2pdf().set(opt).from(element).save();
  };

  const [showInvoice, setShowInvoice] = useState(false);

    return(
    <section className="mb-3 md:mb-4 p-6 md:p-8 xl:p-10">
        <div className="text-base md:text-lg xl:text:xl font-medium flex items-center flex-row space-x-1 mb-5"
             onClick={()=>navigate(-1)}>
            <MdOutlineKeyboardBackspace />
            <p>Invoice Preview</p>
        </div>

        <div className="flex flex-col md:flex-row gap-5">
            <div className="w-3/4 border hidden md:block">
                {service ? (
                    <ServiceInvoice service={service} ref={invoiceRef} />
                ) : (
                    <p className="text-center py-10 text-gray-500">Loading invoice...</p>
                )}
            </div>
            <div className="w-full md:w-1/4 flex flex-col space-y-3 py-5 items-center text-xs md:text-sm xl:text-base">
                <button  className="md:hidden text-center py-1 w-32 border rounded-md border-[#A63F40] bg-[#f5d2d2]
                   text-[#A63F40]  font-medium flex flex-row items-center space-x-1 justify-center"
                    onClick={() => setShowInvoice(true)}
                >
                    <FaEye className="text-base md:text-xl"/>
                    <p>View</p>
                </button>
                <button 
                className="text-center py-1 w-32 border rounded-md border-[#A63F40] bg-[#f5d2d2]
                text-[#A63F40]  font-medium flex flex-row items-center space-x-1 justify-center"
                onClick={handlePrint}
                >
                    <MdLocalPrintshop />
                    <p>Print</p>
                </button>
                <button
                    className="text-center py-1 w-32 border rounded-md border-[#A63F40] bg-[#f5d2d2]
                   text-[#A63F40]  font-medium flex flex-row items-center space-x-1 justify-center"
                    onClick={handleDownload}
                >
                    <IoMdDownload className="text-base md:text-xl"/>
                    <p>Download</p>
                </button>
                <button
                    className="text-center py-1 w-32 border rounded-md border-[#A63F40] bg-[#f5d2d2]
                   text-[#A63F40]  font-medium flex flex-row items-center space-x-1 justify-center"
                    onClick={() => navigate(-1)}
                >
                    <MdOutlineClose />
                    <p>Close Preview</p>
                </button>
            </div>
        </div>
        {showInvoice && (
        <div className="mt-5 w-full flex justify-center">
            <div className="bg-white w-[100%] max-h-[80vh] overflow-auto rounded-lg p-4 shadow-lg">
                <button
                    className="mb-4 px-3 py-1 bg-red-800 text-white rounded"
                    onClick={() => setShowInvoice(false)}
                >
                    Close
                </button>
                {/* <ServiceInvoice
                    service={service}
                    // additionalData={process.invoice.additionalCharges}
                /> */}
            </div>
        </div>
        )}

    </section>
      );
}
